module.exports = __webpack_public_path__ + "assets/pause-btn-icon.png";


//////////////////
// WEBPACK FOOTER
// ./images/ai-preview/pause-btn-icon.png
// module id = 560
// module chunks = 0